// Query staleTime constants (milliseconds)
export const STALE_TIME = {
  /** Master data: chart of accounts, items, tax templates — 1 hour */
  MASTER_DATA: 60 * 60 * 1000,
  /** Settings: modules, company config — 1 hour */
  SETTINGS: 60 * 60 * 1000,
  /** User profile — 30 minutes */
  USER_PROFILE: 30 * 60 * 1000,
  /** Dashboard aggregations — 5 minutes */
  DASHBOARD: 5 * 60 * 1000,
  /** Transaction lists — 2 minutes */
  TRANSACTIONS: 2 * 60 * 1000,
  /** Real-time data: chat, notifications — always fresh */
  REALTIME: 0,
} as const;
